<template>
  <v-container>
    <loader-dialog :showLoader="loading" message="Carregando Despachos..."/>
    <header-for-list-component
      sectionName="Modelos de Despachos"
      :items="dispatches"
      :totalItems="totalItems"
      :totalPages="totalPages"
      :itemsPerPage="itemsPerPage"
      :pageNumber.sync="pageNumber"
      @loadPage="loadPage($event)"
    />

    <v-layout
      align-center
      justify-space-between
      class="mb-3"
    >
      <v-flex xs4>
        <v-text-field
          v-model="search"
          solo
          label="Buscar Despacho"
          prepend-inner-icon="search"
          hide-details
          :loading="loadingSearch"
          @input="typing()"
        >
          <template v-slot:progress>
            <v-progress-linear
              v-if="loadingSearch"
              color="accent"
              indeterminate
              height="3"
            ></v-progress-linear>
          </template>
        </v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex
        xs3
        class="text-xs-right"
      >
        <v-menu offset-y
                content-class="flex-direction-column">
          <template v-slot:activator="{ on }">
            <v-btn
              color="accent"
              flat
              v-on="on"
            >
              <v-icon icon>mdi-plus</v-icon>
              NOVO MODELO DE DESPACHO

            </v-btn>
          </template>
          <v-list>
<!--            <v-list-tile-->
<!--              @click=""-->
<!--            >-->
<!--              <v-list-tile-title>-->
<!--                <v-icon>mdi-upload</v-icon>-->
<!--                Baseado em Arquivo-->
<!--              </v-list-tile-title>-->
<!--            </v-list-tile>-->
            <v-list-tile
              @click="$router.push(`/configuracao/despachos/novo`)"
            >
              <v-list-tile-title>
                <v-icon>mdi-file</v-icon>
                Novo Modelo
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>

    </v-layout>

    <v-layout row>
      <v-flex xs12>
        <v-card>

          <div v-if="dispatches.length === 0">
            <h4 style="text-align: center" class="pa-3">Nenhum despacho cadastro ou encontrado com o termo buscado</h4>
          </div>

          <v-list v-else two-line>
            <template v-for="(item, index) in dispatches">
              <v-list-tile
                :key="item.id"
                avatar
                @click=""
              >
                <v-list-tile-content>
                  <div>
                    <v-tooltip v-if="item.administrative_units.length > 0" top>
                      <v-list-tile-sub-title slot="activator">
                        {{ availableIn(item.administrative_units) }}
                      </v-list-tile-sub-title>
                      {{ administrativeUnitsInDispatch(item.administrative_units) }}
                    </v-tooltip>
                    <span v-else class="v-list__tile__sub-title"> Não está disponível em nenhum setor </span>
                  </div>

                  <v-list-tile-title>
                    {{ item.title }}
                  </v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action class="d-flex">
                  <preview-dispatch :dispatch="item"/>
                  <v-btn icon flat class="mr-2"
                    @click="$router.push(`/configuracao/despachos/editar/${item.id}`)"
                  >
                    <v-icon color="grey darken-1">mdi-pencil</v-icon>
                  </v-btn>
                  <destroy-dispatch @reloadPage="loadPage()" :dispatch="item"></destroy-dispatch>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider
                v-if="index + 1 < dispatches.length"></v-divider>
            </template>

          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>

import HeaderForListComponent from "@/components/settings/HeaderForListComponent";

import DispatchService from '@/services/system/DispatchService';
import AdministrativeUnitService from '@/services/system/AdministrativeUnitService';
import PreviewDispatch from "@/components/settings/dispatches/PreviewDispatch";
import DestroyDispatch from "@/components/settings/dispatches/DestroyDispatch";

import LoaderDialog from '@/components/LoaderDialog';
import {map, join, first} from 'lodash';

export default {
  name: 'DispatchesList',
  components: {HeaderForListComponent, PreviewDispatch, DestroyDispatch, LoaderDialog},
  mounted() {
    AdministrativeUnitService
      .all({all: true})
      .then((res) => {
        this.administrativeUnits = res.data;
      });
    this.loadPage(1);
  },
  data() {
    return {
      search: '',
      loadingSearch: false,
      loading: false,
      administrativeUnits: [],
      dispatches: [],
      totalItems: 0,
      totalPages: 0,
      itemsPerPage: 20,
      pageNumber: 1,
      interval: null,
    };
  },
  methods: {
    administrativeUnitsInDispatch(au) {
      return join(map(au, (item) => {
        return item.name
      }), ', ');
    },
    loadPage(pageNumber) {
      this.pageNumber = pageNumber || this.pageNumber ;
      if (!this.loadingSearch) this.loading = true;
      DispatchService
        .all({
          page: this.pageNumber,
          q: this.search
        })
        .then(({data}) => {
          this.dispatches = data.dispatches || [];
          this.totalItems = data.total;
          this.totalPages = data.total_pages;
        })
        .finally(() => {
          this.loading = false;
          this.loadingSearch = false;
        })
    },
    availableIn(au) {
      if (au.length === 1) return `Disponível em ${ first(au).name }`;
      return `Disponível em ${ first(au).name } e mais ${ au.length - 1 } setor(es)`;
    },
    typing() {
      clearInterval(this.interval)
      this.interval = setTimeout(() => {
        this.loadingSearch = true;
        this.pageNumber = 1;
        this.loadPage()
      }, 500)
    }
  },
};
</script>

<style scoped lang="scss">
  .v-list__tile__action {
    flex-direction: row;
    align-items: center;
    min-width: 100px;
    cursor: default !important;
  }

  .v-list__tile__content{
    cursor: default !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/settings/dispatches/List.vue